export var MessageType;
(function (MessageType) {
  MessageType["SYSTEM_LANGUAGE"] = "SYSTEM_LANGUAGE"
  MessageType["APPLICATION_FINISH"] = "APPLICATION_FINISH"
  MessageType["AUDIO_RESPONSE"] = "AUDIO_RESPONSE"
  MessageType["AUDIO_RECORD_START"] = "AUDIO_RECORD_START"
  MessageType["CAMERA_START"] = "CAMERA_START"
  MessageType["CAMERA_ERROR"] = "CAMERA_ERROR"
  MessageType["CASE_START"] = "CASE_START"
  MessageType["CASE_STOP"] = "CASE_STOP"
  MessageType["DIALOG_ACTION"] = "DIALOG_ACTION"
  MessageType["DIALOG_USER_REPLIC"] = "DIALOG_USER_REPLIC"
  MessageType["DIALOG_REPLIC_START"] = "DIALOG_REPLIC_START"
  MessageType["DIALOG_REPLIC_FINISH"] = "DIALOG_REPLIC_FINISH"
  MessageType["DIALOG_LOAD_REPLIC"] = "DIALOG_LOAD_REPLIC"
  MessageType["DIALOG_LOAD_ANSWER"] = "DIALOG_LOAD_ANSWER"
  MessageType["DIALOG_LOAD_GREETING"] = "DIALOG_LOAD_GREETING"
  MessageType["DIALOG_LOAD_EXTRA_REPLIC"] = "DIALOG_LOAD_EXTRA_REPLIC"
  MessageType["DIALOG_QUESTION_NEW"] = "DIALOG_QUESTION_NEW"
  MessageType["DIALOG_QUESTION_CANCEL"] = "DIALOG_QUESTION_CANCEL"
  MessageType["DRIVE_MODE_MANUAL"] = "DRIVE_MODE_MANUAL"
  MessageType["DRIVE_MODE_AUTO"] = "DRIVE_MODE_AUTO"
  MessageType["DRIVE_STATUS_IDLE"] = "DRIVE_STATUS_IDLE"
  MessageType["DRIVE_STATUS_START"] = "DRIVE_STATUS_START"
  MessageType["DRIVE_STATUS_CANCEL"] = "DRIVE_STATUS_CANCEL"
  MessageType["DRIVE_STATUS_FINISH"] = "DRIVE_STATUS_FINISH"
  MessageType["DRIVE_STATUS_OBSTACLE"] = "DRIVE_STATUS_OBSTACLE"
  MessageType["DRIVE_CHARGE_STATUS_IDLE"] = "DRIVE_CHARGE_STATUS_IDLE"
  MessageType["DRIVE_CHARGE_STATUS_SUCCESS"] = "DRIVE_CHARGE_STATUS_SUCCESS"
  MessageType["DRIVE_CHARGE_STATUS_FAIL_CONNECT"] = "DRIVE_CHARGE_STATUS_FAIL_CONNECT"
  MessageType["DRIVE_CHARGE_STATUS_FAIL_FIND_MARKER"] = "DRIVE_CHARGE_STATUS_FAIL_FIND_MARKER"
  MessageType["KEYBOARD_VISIBLE_CHANGE"] = "KEYBOARD_VISIBLE_CHANGE"
  MessageType["RESTART"] = "RESTART"
  MessageType["CUSTOM"] = "CUSTOM"
  MessageType["SIP_STATUS_CHANGE"] = "SIP_STATUS_CHANGE"
  MessageType["SIP_TONE_EVENT"] = "SIP_TONE_EVENT"
  MessageType["INTERACTION_START"] = "INTERACTION_START"
  MessageType["INTERACTION_STOP"] = "INTERACTION_STOP"
  MessageType["SETTINGS_UPDATE"] = "SETTINGS_UPDATE"
  MessageType["FACE_RECOGNIZE_INFO"] = "FACE_RECOGNIZE_INFO"
  MessageType["FACE_RECOGNIZE_GENERAL"] = "FACE_RECOGNIZE_GENERAL"
  MessageType["FACE_RECOGNIZE_GENERAL_SETTED"] = "FACE_RECOGNIZE_GENERAL_SETTED"
  MessageType["FACE_RECOGNIZE_MATCH_SCORE"] = "FACE_RECOGNIZE_MATCH_SCORE"
  MessageType["FACE_MATCH_SCORE"] = "FACE_MATCH_SCORE"
  MessageType["FACE_ADD_START"] = "FACE_ADD_START"
  MessageType["FACE_ADD_STATUS"] = "FACE_ADD_STATUS"
  MessageType["PUSH_ADDED"] = "PUSH_ADDED"
  MessageType["MAIL_SUCCESS"] = "MAIL_SUCCESS"
  MessageType["MAIL_ERROR"] = "MAIL_ERROR"
  MessageType["RFID_STATUS"] = "RFID_STATUS"
  MessageType["RFID_CONNECTED"] = "RFID_CONNECTED"
  MessageType["RFID_ERROR"] = "RFID_ERROR"
  MessageType["RFID_RESULT"] = "RFID_RESULT"
  MessageType["PRINTER_SUCCESS"] = "PRINTER_SUCCESS"
  MessageType["PRINTER_ERROR"] = "PRINTER_ERROR"
  MessageType["PRINTER_INFO"] = "PRINTER_INFO"
  MessageType["PRINTER_LOW_PAPER"] = "PRINTER_LOW_PAPER"
  MessageType["PRINTER_NO_PAPER"] = "PRINTER_NO_PAPER"
  MessageType["PRINTER_NO_PRINTER"] = "PRINTER_NO_PRINTER"
  MessageType["SCRIPT_END"] = "SCRIPT_END"
  MessageType["BARCODE_STATUS"] = "BARCODE_STATUS"
  MessageType["BARCODE_CONNECTED"] = "BARCODE_CONNECTED"
  MessageType["BARCODE_ERROR"] = "BARCODE_ERROR"
  MessageType["BARCODE_RESULT"] = "BARCODE_RESULT"
  MessageType["DISPENSER_FULL_STATUS"] = "DISPENSER_FULL_STATUS"
  MessageType["OPERATOR_CALL_START"] = "OPERATOR_CALL_START"
  MessageType["OPERATOR_CALL_RESPONSE"] = "OPERATOR_CALL_RESPONSE"
  MessageType["OPERATOR_CONTROL_STATUS"] = "OPERATOR_CONTROL_STATUS"
  MessageType["PAYMENT_TERMINAL_STATUS"] = "PAYMENT_TERMINAL_STATUS"
  MessageType["FINGERPRINT_SCANNER_START"] = "FINGERPRINT_SCANNER_START"
  MessageType["FINGERPRINT_SCANNER_ERROR"] = "FINGERPRINT_SCANNER_ERROR"
  MessageType["FINGERPRINT_SCANNER_STATE"] = "FINGERPRINT_SCANNER_STATE"
  MessageType["FINGERPRINT_SCANNER_STATUS"] = "FINGERPRINT_SCANNER_STATUS"
  MessageType["FINGERPRINT_SCANNER_FINISH"] = "FINGERPRINT_SCANNER_FINISH"
})(MessageType || (MessageType = {}))
